import { BidCategoryView, OpportunityBidCategoryView } from '@api-proxies';
import { BidCategoryService } from '@http/clients/bid-category.service';
import { BidCategoryEntity } from './abstract/bid-category-entity';

export class OpportunityBidCategoryEntity extends BidCategoryEntity<OpportunityBidCategoryView> {
    constructor(bidCategoryService: BidCategoryService) {
        super(bidCategoryService);
    }

    toDestination(entity: BidCategoryView): OpportunityBidCategoryView {
        return {
            id: 0,
            bidCategoryId: entity.id,
            bidCategoryName: entity.name
        };
    }

    toSource(entity: OpportunityBidCategoryView): BidCategoryView {
        return {
            id: entity.bidCategoryId,
            name: entity.bidCategoryName
        };
    }
}
